/**
 * Translations (i18next). Every static string in the UI comes from
 * locales/en.json and locales/da.json - use the useTranslation() hook:
 *   const { t } = useTranslation();
 *   t("area.key")                           -> "Some text"
 *   t("area.count", { count: 2 })           -> plural forms (key_one/key_other)
 *
 * The language is the one the user picked (saved on their account and on
 * this device), otherwise the browser's language, otherwise English.
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import da from "./locales/da.json";

export const LANGUAGES = [
  { code: "en", name: "English" },
  { code: "da", name: "Dansk" },
];

// Only a language the user picked is stored here - never the detected one
export const LANGUAGE_STORAGE_KEY = "somigo-language";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, da: { translation: da } },
    supportedLngs: LANGUAGES.map((language) => language.code),
    load: "languageOnly", // "da-DK" -> "da"
    fallbackLng: "en",
    interpolation: { escapeValue: false }, // React escapes already
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: [],
    },
  });

const setDocumentLanguage = (language) => {
  document.documentElement.lang = language;
};
setDocumentLanguage(i18n.resolvedLanguage);
i18n.on("languageChanged", setDocumentLanguage);

export default i18n;
